import React, {Component} from 'react'
import {Control, Errors} from 'react-redux-form'
import {FormGroup, ControlLabel, FormControl} from 'react-bootstrap'
import PropTypes from 'prop-types';
import {validators} from "../../../../utils/validators"
import LayoutContainer from "../../../layout/layout-container/index";
import RequiredInput from '../elements/required-input'

class SecurityQuestionAnswerInput extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render(){
    const {questionModel, questionLabel, questionControlId,
      answerModel, answerLabel, answerPlaceHolder, answerControlId, questions} = this.props;

    return (
      <LayoutContainer>
        <FormGroup controlId={questionControlId} validationState={this.state.security_question}>
          {questionLabel && <ControlLabel>{questionLabel}*</ControlLabel>}
          <Control.select
            model={questionModel}
            component={FormControl}
            validators={{required: validators.required(this.updateErrors, 'security_question')}}
            componentClass="select">
            <option key="-1" disabled>Select a question...</option>
            {questions && questions.map((question, index) =>
              <option key={question.id} value={question.id}>{question.attributes.name}</option>)
            }
          </Control.select>

          <Errors
            show={{touched: true,focus: false}}
            className="errors"
            model={questionModel}
            messages={{required: 'This field is required'}}/>
        </FormGroup>

        <RequiredInput
          model={answerModel}
          controlId={answerControlId}
          label={answerLabel}
          placeholder={answerPlaceHolder}
        />

      </LayoutContainer>
    )
  }
}

SecurityQuestionAnswerInput.propTypes = {
  questions: PropTypes.array.isRequired,
  questionModel: PropTypes.string.isRequired,
  questionControlId: PropTypes.string,
  questionLabel: PropTypes.string,
  answerModel: PropTypes.string.isRequired,
  answerControlId: PropTypes.string,
  answerLabel: PropTypes.string,
  answerPlaceHolder: PropTypes.string,
};

SecurityQuestionAnswerInput.defaultProps = {
  questionControlId: 'securityQuestion',
  questionLabel: 'Security question 1',
  answerControlId: 'securityAnswer',
  answerLabel: 'Security answer 1',
  answerPlaceHolder: 'Security answer 1'
};

export default SecurityQuestionAnswerInput;


// WEBPACK FOOTER //
// ./src/components/common/form/user/security-question-answer-input.jsx